module.exports = __webpack_public_path__ + "static/img/film.89f5c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/film.jpg
// module id = OKlX
// module chunks = 1